import { useState } from "react";
import { Outlet } from "react-router-dom";
import { Sidebar } from "../sidebar/Sidebar";
import { PerfilUsuario } from "../../usuario/perfil/PerfilUsuario";
import { useAuth } from "../../../contexts/AuthContext";
import { Bell } from "lucide-react";
import { PopupNotificacoes } from "../../notificacao/Notificacao";
import { useNotificacoes } from "../../../hooks/useNotificacoes";
import Style from "./index.module.css";

export const LayoutWithSidebar = ({ sidebarItems }) => {
  const { user } = useAuth();
  const [showNotificacoes, setShowNotificacoes] = useState(false);

  const [periodo, setPeriodo] = useState({
    datIni: new Date(new Date().setDate(new Date().getDate() - 7)),
    datFim: new Date(),
  });

  const { data: notificacoes, qtdNaoLidas, isLoading: isLoadingNotificacoes, marcarComoLida } = useNotificacoes(
    user,
    periodo.datIni,
    periodo.datFim
  );

  const handlePeriodoChange = (datIni, datFim) => {
    setPeriodo((prev) => {
      if (
        prev.datIni.getTime() === datIni.getTime() &&
        prev.datFim.getTime() === datFim.getTime()
      ) {
        return prev;
      }
      return { datIni, datFim };
    });
  };

  const allowedItems = sidebarItems.filter((item) =>
    item.roles?.includes(user?.tipusu)
  );

  return (
    <div className={Style.layoutSidebar}>
      <Sidebar items={allowedItems} />
      <main className={Style.content}>
        <div className={Style.perfilTopo}>
          <div
            className={Style.notificacao}
            onClick={() => setShowNotificacoes((prev) => !prev)}
          >
            <Bell size={22} />
            {qtdNaoLidas > 0 && (
              <span className={Style.badge}>
                {qtdNaoLidas > 99 ? "99+" : qtdNaoLidas}
              </span>
            )}
          </div>

          <PopupNotificacoes
            show={showNotificacoes}
            isLoading={isLoadingNotificacoes}
            onChange={handlePeriodoChange}  
            onClose={() => setShowNotificacoes(false)}
            notificacoes={notificacoes}
            onMarcarComoLida={marcarComoLida}
          />

          <PerfilUsuario />
        </div>
        <Outlet />
      </main>
    </div>
  );
};
